<template>
  <v-app>
      <v-main style="height: 100%;">
        <v-container>
          <v-layout :is="layout">
              <router-view></router-view>
          </v-layout>

        </v-container>

    </v-main>
    <!--<loader :value="loading !== null" :message="loading"></loader>-->
  <v-overlay :value="loading" :opacity=".7">
      <div class="loader">
          <v-progress-circular indeterminate size="45"></v-progress-circular>
          <span>{{ loading }}</span>
      </div>
  </v-overlay>
    <v-dialog
            v-model="upgrade"
            max-width="290"
            persistent
    >
      <v-card>
        <v-card-title class="headline">Upgrade Available</v-card-title>

        <v-card-text>
          There is an application upgrade available
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
                  color="primary lighten-1"
                  text
                  @click="cancel()"
          >
            Not now
          </v-btn>

          <v-btn
                  color="primary lighten-1"
                  text
                  @click="upgradeApp"
          >
            Upgrade now
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-btn
            v-if="offline"
            color="error"
            light
            small
            fixed
            top
            right
            fab
    >
      <v-icon>wifi_off</v-icon>
    </v-btn>
    <v-dialog
            v-if="error"
            v-model="error"
            width="500"
    >

      <v-card>
        <v-card-title
                class="headline error"

        >
          <span class="text--white" style="color: white;">{{ error.header }}</span>
        </v-card-title>

        <v-card-text>
          {{ error.text }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn
                  color="error"
                  text
                  @click="error = null"
          >
            {{ error.button }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
            v-if="message"
            v-model="message"
            width="500"
            scrollable
    >
      <v-card>
        <v-card-title
                class="headline"
                :class="message.text_colour + '--text ' + message.colour"
        >
          {{ message.title }}
        </v-card-title>

        <v-card-text v-html="message.body"></v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-checkbox
                  v-model="hideMessage"
                  label="Don't display again"
          ></v-checkbox>
          <v-btn
                  :color="message.colour"
                  text
                  @click="dismissMessage"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </v-app>
</template>

<script>
// import HelloWorld from './components/HelloWorld'
// import Initialize from './components/Initialize.vue'
// import ConversationContainer from './components/ConversationContainer.vue'
import { mapState, mapGetters } from 'vuex'
import Loader from './components/Loader'


const defaultLayout = 'blank'

export default {
  name: 'App',
  mounted () {
    //this.$store.dispatch('auth/initialise')
    if(!window.navigator.onLine) {
      this.$store.commit('global/SET_OFFLINE', true)
    }
  },
  components: {
      Loader
    // Initialize,
    // ConversationContainer
  },
  data () {
    return {
      drawer: null,
      snackbar: true,
      hideMessage: false
    }
  },
  methods: {
    cancel () {
      var check_upgrade = new Event('check-for-upgrade')
      setTimeout(() => {
        window.dispatchEvent(check_upgrade)
      }, 1000*60)
      this.$store.commit('global/CANCEL_UPGRADE')
    },
    upgradeApp () {
      window.location.reload(true)
    },
    dismissMessage () {
      this.$store.dispatch('messages/dismissMessage', this.hideMessage)
      this.hideMessage = false
    }
  },
  computed: {
    ...mapGetters({
      message: 'messages/message',
      messages: 'messages/messages',
    }),
    ...mapState({
      loading: state => {
          if(state.global.syncing) return state.global.syncing
          if(state.Global.loading) return state.Global.loading
          return false
      },
      upgrade: state => state.global.upgrade && !state.global.syncing,
      offline: state => state.global.offline,
      error: state => state.global.error,
    }),
    error: {
      get () {
        return this.$store.state.global.error
      },
      set (value) {
        return this.$store.dispatch('global/setError', value)
      }
    },
    layout () {
      return (this.$route && this.$route.meta.layout || defaultLayout) + '-layout'
    }
  }
}
</script>

<style lang="scss">

  @font-face {
    font-family: 'DIN Alternate Bold';
    src: url('./assets/fonts/DIN Condensed Bold.ttf');
  }

  @font-face {
    font-family: 'DIN Condensed Bold';
    src: url('./assets/fonts/DIN Condensed Bold.ttf');
  }

  .v-application {
      height: 100vh;
      height: -webkit-fill-available;
  }

  .v-application--wrap {
      min-height: 100vh !important;
      min-height: -webkit-fill-available !important;
  }

  html,
  body {
    -webkit-user-select: none;
    background: #FFFFFF;
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;
  }

  body {
    overscroll-behavior-y: contain;
  }

  body.has-refresh {
    overscroll-behavior-y: auto !important;
  }

  .loader {
      flex-direction: column;
      display: flex;
      align-items: center;
      span {
          margin-top: 20px;
          text-transform: uppercase;
      }
  }

  .container {
    padding: 0 !important;
  }

  h3.blank-header {
    font-family: 'DIN Alternate Bold';
    text-align: center;
    font-size: 26px;
    margin-bottom: 20px;
      text-transform: uppercase;
  }

  .user-welcome-text {
    h3 {
      font-size: 22px;
      font-family: 'DIN Alternate Bold';
      text-transform: uppercase;
      line-height: 24px;
      margin-top: 20px;
    }
  }

  .v-footer {
    padding: 20px 20px 40px;
    background: #ffffff;
    border-top: solid 1px rgba(0,0,0,.12);
  }

  .footer-link {
    text-decoration: none;
    font-size: 16px;
    font-weight: bold;
  }

  .primary-title {
    text-align: center;
    background: #24ADBB !important;
    height: 27px;
    border-bottom: none;
    margin-top: 20px;
    h3 {
      font-family: 'DIN Alternate Bold';
      text-transform: uppercase;
      font-size: 18px !important;
      color: #FFFFFF;
      text-align: center;
      margin: 5px auto 0 !important;
      padding: 0;
      line-height: 0;
    }
  }
  .full-height {
    min-height: calc(100vh - 100px);
  }
  .v-btn--active {
    background: transparent;
  }
  .v-dialog__content {
    z-index: 99999 !important;
  }

  .v-footer {
      padding: 10px 0;
  }

  .top-nav {
    display: flex;
    position: fixed;
    z-index: 999;
    background: #FFFFFF;
    width: 100%;
    top: 0;
    & + div {
      margin-top: 50px !important;
    }
  }

  .v-overlay {
    z-index: 999 !important;
  }

  @media print {
    .top-nav {
      display: none;
    }
    .recipe-image {
      display: none !important;
    }
    .footer-nav {
      display: none !important;
    }
    .v-bottom-navigation {
      display: none !important;
    }
  }


  .data-overlay {
      position: relative;
      .v-overlay {
          z-index: 999 !important;
      }
      .v-card__text {
          font-size: 16px;
      }
  }

</style>
